import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Alert,
  Badge,
} from "reactstrap";
import { Line } from "react-chartjs-2";
import classNames from "classnames";
import { chartOptions, buildChart } from "../../helpers/utils";
import useToken from "../../helpers/useToken";
import useTimeZone from "../../helpers/useTimeZone";
import TMHLoader from "../TMHLoader/TMHLoader";

export default function RokuRemoteAppChart() {
  const [labels, setLabels] = useState([]);
  const [newUserData, setNewUserData] = useState();
  const [activeUserData, setActiveData] = useState();
  const [dataLabel, setDataLabel] = useState("New User");
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useToken();
  const { timeZone } = useTimeZone();

  useEffect(() => {
    async function initData() {
      console.log("RokuRemoteAppChart: update data");
      setIsLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      var params = new URLSearchParams({
        timezone_offset_minutes: timeZone * -60,
      });

      fetch(
        process.env.REACT_APP_BASE_URL + "roku_remote/overview?" + params,
        requestOptions
      )
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then(async (result) => {
          var json = result.json;
          if (result.ok) {
            var datasets = json?.data.datasets;
            var labels = json?.data.labels;
            setNewUserData(datasets["NewUser"]);
            setActiveData(datasets["ActiveUser"]);
            setLabels(labels);
            setIsLoading(false);
          } else {
            console.log(result.json.message);
            setIsLoading(false);
          }
        });
    }

    initData();
  }, [setIsLoading, token, timeZone]);

  return (
    <TMHLoader active={isLoading}>
      <Row>
        <Col sm="12">
          <Card className="card-chart">
            <CardHeader>
              <Row>
                <Col className="text-left" sm="6">
                  <h5 className="card-category">
                    Total Users Synced For SimpleRokuRemote
                  </h5>
                  <CardTitle tag="h2">{dataLabel}</CardTitle>
                </Col>
                <Col sm="6">
                  <ButtonGroup
                    className="btn-group-toggle float-right"
                    data-toggle="buttons"
                  >
                    <Button
                      tag="label"
                      className={classNames("btn-simple", {
                        active: dataLabel === "New User",
                      })}
                      color="info"
                      id="0"
                      size="sm"
                      onClick={() => {
                        setDataLabel("New User");
                      }}
                    >
                      <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                        New User
                      </span>
                      <span className="d-block d-sm-none">
                        <i className="tim-icons icon-single-02" />
                      </span>
                    </Button>
                    <Button
                      tag="label"
                      className={classNames("btn-simple", {
                        active: dataLabel === "Active User",
                      })}
                      color="info"
                      id="0"
                      size="sm"
                      onClick={() => {
                        setDataLabel("Active User");
                      }}
                    >
                      <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                        Active User
                      </span>
                      <span className="d-block d-sm-none">
                        <i className="tim-icons icon-single-02" />
                      </span>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <div className="chart-area">
                {newUserData && dataLabel === "New User" && (
                  <Line
                    data={buildChart(labels, newUserData["data"])}
                    options={chartOptions(true)}
                  />
                )}
                {activeUserData && dataLabel === "Active User" && (
                  <Line
                    data={buildChart(labels, activeUserData["data"])}
                    options={chartOptions(true)}
                  />
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col sm="6" md="6" lg="4">
          <Card>
            <CardHeader>
              <CardTitle className="text-info" tag="h4">
                App Downloads Summary
              </CardTitle>
              <Alert color="warning">
                <span>
                  <i className="tim-icons icon-bullet-list-67 text-success" />{" "}
                  Total{" "}
                  <Badge color="default" pill>
                    {newUserData?.total}
                  </Badge>
                </span>
              </Alert>
              <Alert color="success">
                <i className="tim-icons icon-bullet-list-67 text-success" />{" "}
                Today{" "}
                <Badge color="default" pill>
                  {newUserData?.today}
                </Badge>
              </Alert>
              <Alert color="danger">
                <i className="tim-icons icon-bullet-list-67 text-success" />{" "}
                Yesterday{" "}
                <Badge color="default" pill>
                  {newUserData?.yesterday}
                </Badge>
              </Alert>
            </CardHeader>
          </Card>
        </Col>
      </Row>
    </TMHLoader>
  );
}
